import { Action } from '@ngrx/store';
/**
 * @deprecated Since version 4.1. Will be deleted in version 5.0.
 * @param {?} action
 * @return {?}
 */
export function toPayload(action: Action): any {
  return ( /** @type {?} */((action as any))).payload;
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/util.ts